import { atom } from "recoil";
import { Message } from "../model";

export const messageState = atom<Message | undefined>({
  key: "messageState",
  default: undefined
})